// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apple-pay-button {\n  display: inline-block;\n  -webkit-appearance: -apple-pay-button;\n  -apple-pay-button-type: check-out;\n  width: 250px;\n  height: 34px;\n}\n.apple-pay-button-black {\n  -apple-pay-button-style: black;\n}\n.apple-pay-button-white {\n  -apple-pay-button-style: white;\n}\n.apple-pay-button-white-with-line {\n  -apple-pay-button-style: white-outline;\n}\n", ""]);
// Exports
module.exports = exports;
